/**
 * Suspense fallback for the lazy-loaded route surfaces in `AppRoutes` (route-level
 * code-splitting). Kept intentionally tiny and dependency-light so it stays in the
 * initial bundle and paints instantly while a module chunk downloads.
 *
 * Accessible + token-first (ADR-015): a polite live region announces the transition
 * to assistive tech (NF-10); colours come from `tokens.css` via Tailwind token
 * utilities (no raw hex/px). No spinner animation — a text status avoids a
 * motion concern for reduced-motion users and needs no extra markup.
 */
export function RouteLoading() {
  return (
    <div role="status" aria-live="polite" className="flex min-h-40 items-center justify-center">
      <span className="text-base text-text-secondary">Loading…</span>
    </div>
  );
}
